import { DARK_GREEN, GREY4 } from '@swegon-core/uic/dist/src/theme';
import styled from 'styled-components';

type ProductVariantImageProps = {
    src: string;
};

type DimensionLineProps = {
    $position: 'bottom-left' | 'bottom' | 'right' | 'top';
};

type DimensionTextProps = {
    $position?: 'bottom-left' | 'bottom' | 'right' | 'top';
};

const MIN_HEIGHT_TITLE = '2rem';
const MIN_HEIGHT_TAGLINES = '2rem';
const MIN_HEIGHT_IMAGE = '35vh';

export const ProductVariantBasicInfoContainer = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

export const TextLoaderContainer = styled.div`
    min-width: 35vw;
    min-height: calc(
        4rem + 12px
    ); // min-height and padding of AhuTitle and TagLineContainer
`;

export const ProductVariantTitle = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: ${MIN_HEIGHT_TITLE};
    margin: 0;
    font-size: 24px;
    font-weight: 400;
`;

export const TagLineContainer = styled.ul`
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: ${MIN_HEIGHT_TAGLINES};
    margin: 0;
    padding: 6px;
    list-style-type: disc;
    li:only-child {
        list-style-type: none;
    }
`;

export const TagLineItem = styled.li`
    text-align: center;
    margin: 0 1rem;
    color: ${DARK_GREEN};
    -webkit-text-fill-color: ${GREY4};
    font-size: 0.875rem;
    font-weight: 200;
`;

export const ImageLoaderWrapper = styled.div`
    min-width: 35vw;
    min-height: ${MIN_HEIGHT_IMAGE};
    padding: 1rem;
`;

export const ProductVariantImageContainer = styled.div`
    display: grid;
    justify-content: center;
    align-items: center;
    grid-template-columns: 15em 5em 26em 15em;
    grid-template-rows: 1.5em 18em 1.5em 1.5em;
`;

export const ProductVariantImage = styled.img<ProductVariantImageProps>`
    height: auto;
    width: 100%;
    object-fit: contain;
    align-self: center;
    grid-column: 2 / span 2;
    grid-row: 2 / span 2;
    src: ${(props: { src: string }) => props.src};
`;

export const DimensionsTable = styled.table`
    display: block;
    grid-row: 2;
    grid-column: 4;
`;

export const DimensionLineContainer = styled.div<DimensionLineProps>`
    display: ${(props) => (props.$position === 'top' ? 'flex' : 'grid')};
    justify-content: center;
    align-items: center;
    z-index: 99;
    margin: 0.25em;
    transform: ${(props) => {
        switch (props.$position) {
            case 'bottom-left':
                return 'rotate(25deg)';
            case 'right':
                return 'rotate(-90deg)';
            default:
                return 'rotate(0deg)';
        }
    }};
    grid-row: ${(props) => {
        switch (props.$position) {
            case 'top':
                return '1';
            case 'right':
                return '2 / span 2';
            case 'bottom-left':
                return '3';
            default:
                return '4';
        }
    }};
    grid-column: ${(props) => {
        switch (props.$position) {
            case 'right':
                return '4';
            case 'bottom-left':
                return '2';
            default:
                return '3';
        }
    }};
`;

export const DimensionText = styled.label<DimensionTextProps>`
    width: ${(props) => {
        switch (props?.$position) {
            case 'right':
                return '50%';
            case 'top':
                return 'fit-content';
            default:
                return '100%';
        }
    }};
    text-align: ${(props) => (props?.$position === 'right' ? 'end' : 'center')};
    writing-mode: ${(props) =>
        props?.$position === 'right' ? 'vertical-rl' : 'horizontal-tb'};
    margin: ${(props) =>
        props?.$position === 'top' ? '0.5em 0em 0em 0.5em' : '0 0 0 1em'};
`;

export const LoadingWrapper = styled.div`
    min-height: calc(
        ${MIN_HEIGHT_IMAGE} + ${MIN_HEIGHT_TAGLINES} + ${MIN_HEIGHT_TITLE}
    );
    min-width: 100%;
`;
